<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2023-07-21 12:13:41
-->
<template>
  <div class="header-box">
    <logo-box></logo-box>
    <nav-bar></nav-bar>
  </div>
</template>

<script>
import logoBox from '@/components/logoBox/index.vue'
import navBar from '@/components/navBar/index.vue'
export default {
  components: {
    logoBox,
    navBar
  }
}
</script>
<style lang="scss" scoped>
</style>